import actionTypes from '../../actions/dictionaries/dictionaries.action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_REPORT_CATEGORIES_DICTIONARY_SUCCESS:
      return { ...action.categories };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/modules/app/reducers/dictionaries/report-categories-dictionary.js